import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ServiceModalAction } from '../../actions/ServiceModalAction';
import { Translate as t } from '../../config/Translate';
import { isAdminPathname } from '../../lib/isAdminPathname';

const pulseKeyframes = `
@keyframes serviceModalPulse {
	0%, 100% { transform: scale(1); }
	50% { transform: scale(1.15); }
}
`;

const ServiceModalWarningIcon = ({ pendingCount, showModal, ShowModal, GetPendingAlerts, GetIssueManagers, companyId, issueManagerIds, issueManagersLoaded, countsLoaded, userAdminId, enabled }) => {
	const location = useLocation();
	const isAdminPath = isAdminPathname(location.pathname);

	useEffect(() => {
		if (isAdminPath) {
			GetPendingAlerts();
			if (companyId) GetIssueManagers(companyId);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- stable refs from mapDispatch
	}, [isAdminPath, companyId]);

	if (!isAdminPath) return null;

	// BUG-056: API 응답 전 숨김 판단 보류
	if (!countsLoaded || !issueManagersLoaded) return null;

	// 노출 조건: serviceStatusEnabled + Issue Manager 등록 사용자 + pending 존재
	const isIssueManager = issueManagerIds.includes(userAdminId);
	if (!enabled || !isIssueManager || pendingCount === 0) return null;

	const handleClick = () => {
		if (!showModal) {
			ShowModal('ISSUE_ALERT', null);
		}
	};

	const iconStyle = {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		position: 'relative',
		cursor: 'pointer',
		marginLeft: '8px',
		padding: '4px',
	};

	const badgeStyle = {
		position: 'absolute',
		top: '-4px',
		right: '-6px',
		minWidth: '18px',
		height: '18px',
		borderRadius: '9px',
		backgroundColor: '#dc3545',
		color: '#fff',
		fontSize: '11px',
		fontWeight: 'bold',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '0 4px',
		lineHeight: 1,
		animation: 'serviceModalPulse 2s ease-in-out infinite',
	};

	return (
		<>
			<style>{pulseKeyframes}</style>
			<div
				onClick={handleClick}
				style={iconStyle}
				title={t('service.issueManager.pendingAlerts') + ': ' + pendingCount}
			>
				<ion-icon name="warning-outline" style={{ fontSize: '22px', color: '#ffc107' }}></ion-icon>
				<span style={badgeStyle}>{pendingCount > 99 ? '99+' : pendingCount}</span>
			</div>
		</>
	);
};

const mapState = (state) => ({
	pendingCount: state.ServiceModalReducer.pendingCount,
	showModal: state.ServiceModalReducer.showModal,
	companyId: state.AuthReducer?.user?.companyId || '',
	issueManagerIds: state.ServiceModalReducer.issueManagerIds,
	issueManagersLoaded: state.ServiceModalReducer.issueManagersLoaded,
	countsLoaded: state.ServiceStatusReducer.countsLoaded,
	userAdminId: state.AuthReducer?.user?.adminid || '',
	enabled: state.ServiceStatusReducer.enabled,
});

const mapDispatch = (dispatch) => ({
	ShowModal: (modalType, alertData) => dispatch(ServiceModalAction.ShowModal(modalType, alertData)),
	GetPendingAlerts: () => dispatch(ServiceModalAction.GetPendingAlerts()),
	GetIssueManagers: (companyId) => dispatch(ServiceModalAction.GetIssueManagers(companyId)),
});

export default connect(mapState, mapDispatch)(ServiceModalWarningIcon);
